import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import DownloadFilesTable from 'components/common/download-files/DownloadFilesTable';

import TableInfoBar, { TotalFilesLabel } from 'components/common/download-files/TableInfoBar';
import ZipFileSection from 'components/common/download-files/ZipFileSection';
import { ActionModal, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { getZipAvailabilityNote } from 'global/utils/fileAvailability';

const SummaryTable: React.FC = observer(() => {
  const { periodId } = useParams<{ periodId: string }>();

  const {
    summaryTableStore: {
      outputFiles,
      finalCsvZip,
      loading,
      isWarningModalOpen,
      buildSummaryList,
      resetData,
      downloadCsvFile,
      downloadFinalZip,
      updateModalShowStatus,
    },
  } = useRootStore();

  useEffect(() => {
    void buildSummaryList(periodId);
    return resetData;
  }, []);

  return (
    <>
      {loading ? (
        <OverlaySpinner display={loading} overlay="none" />
      ) : (
        <>
          {finalCsvZip.id && (
            <>
              <TableInfoBar title="Final ZIP" rightContent={getZipAvailabilityNote(finalCsvZip)} />
              <ZipFileSection file={finalCsvZip} onDownload={downloadFinalZip} />
            </>
          )}

          <TableInfoBar title="Summary Files" rightContent={<TotalFilesLabel filesAmount={outputFiles.length} />} />
          <DownloadFilesTable loading={loading} filesList={outputFiles} onDownload={downloadCsvFile} />
          <ActionModal
            show={isWarningModalOpen}
            onClose={(): void => {
              updateModalShowStatus(false);
            }}
            title={
              <span>
                Enrollment output files are currently being generated.
                <br /> Please check back in a minute.
              </span>
            }
            modalType={ModalType.NOTIFICATION}
          />
        </>
      )}
    </>
  );
});

export default SummaryTable;
